import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5 12a7 7 0 1 1 7 7v4c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12zm3 2.5v4H5V16H2.5v2.5H5v3h3v-3h4v-4z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandSoftwareDevelopmentDigitalOcean = { render };
export {
  brandSoftwareDevelopmentDigitalOcean as default,
  render
};
//# sourceMappingURL=brand-software-development-digital-ocean.svg.js.map
